<template>
    <div class="desing">
        <titles name="设计信息"></titles>
        <ul class="content">
            <li>
                <div class="titleDiv">
                    设计师： 
                    <span class="titleSpan">{{item.designerName}} | {{item.designerPhone}}</span>
                </div>
                <div class="titleDiv">
                    设计师电话： 
                    <span class="titleSpan">{{item.designerPhone}}</span> 
                </div>
                <!-- <div class="titleDiv">
                    汇报时间：
                    <span class="titleSpan">2018-06-27 10:30</span> 
                </div> -->
                <!-- <div class="flex-row titleDiv">
                    <p class="m-r-51">附件汇报</p>
                    <div class="titleSpan">
                        <img class="m-r-20" :src="lion" alt="">
                        <img :src="lion" alt="">
                    </div>
                </div> -->
            </li>
        </ul>
    </div>
</template>
<script>
import titles from '@/components/titiles.vue';
import lion from '@/assets/img/lion.jpg'
export default {
    components:{
        titles,
    },
    props: {
        item: {
        type: Object,
        default: {}
        },
    },
    data(){
        return {
            lion
        }
    }
}
</script>
<style lang="scss" scoped>
.desing{
    background: $ffff;
    padding-bottom: 2px;
    margin-bottom: 20px;
    .content{
        margin:20px 55px 0 55px;
        background: $ffff;
        font-size:24px;
        color:$color-51;
        li{
            div{
                margin-bottom: 27px;
            }
            img{
                width:110px;
                height:110px;
            }
        }
        span{
            color: $color-153;
        }
    }
}
.titleDiv{
    position: relative;
    .titleSpan{
        position: absolute;
        left: 150px;
    }
}
</style>


